import React, { useState, useEffect } from 'react';
import PageTemplate from '../../components/Common/PageTemplate';
import { FaChevronDown, FaEnvelope, FaMicroscope, FaLeaf, FaDna, FaFlask, FaUsers, FaGraduationCap } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';
import './Biology.css';

// --- Veri Bölümü ---

const managementData = [
  {
    name: "Prof. Dr. Işık PERÇİN DEMİRÇELİK",
    title: "Bölüm Başkanı",
    img: "https://avesis.hacettepe.edu.tr/user/image/6813",
    email: "ipercin@hacettepe.edu.tr",
  },
  {
    name: "Doç. Dr. Emel SAĞLAR ÖZER",
    title: "Bölüm Başkan Yardımcısı",
    img: "https://avesis.hacettepe.edu.tr/user/image/5074",
    email: "esaglar@hacettepe.edu.tr",
  },
  {
    name: "Doç. Dr. Esin AKBAY ÇETİN",
    title: "Bölüm Başkan Yardımcısı",
    img: "https://avesis.hacettepe.edu.tr/user/image/5064",
    email: "esin.akbay@hacettepe.edu.tr",
  },
  {
    name: "Doç. Dr. Beril ERDEM TUNÇDEMİR",
    title: "Koordinatör",
    img: "https://avesis.hacettepe.edu.tr/user/image/8313",
    email: "beril@hacettepe.edu.tr",
  },
];

const anaBilimDallariData = [
    {
      title: 'Biyoteknoloji',
      content: `
        <p>Biyoteknoloji Ana Bilim Dalımız Genel Biyoloji Ana Bilim Dalı ve Moleküler Biyoloji Ana Bilim Dalı bünyesinde yer alan öğretim üyeleri ve yardımcılarının katılımlarıyla 1992 yılında kurulmuştur. Kuruluşundan itibaren Ana Bilim Dalı Başkanlığı'nı Prof. Dr. Nazif KOLANKAYA, Prof. Dr. Nilüfer AKSÖZ ve Prof. Dr. Reyhan ÖNER üstlenmişlerdir. 2008 yılından bu yana Prof. Dr. Nilüfer AKSÖZ Ana Bilim Dalımız Başkanlığı'nı sürdürmektedir.</p>
        <p>Biyoteknoloji, canlılar ve canlı sistemler ile bilim ve mühendislik teknikleri uygulanarak mal ve hizmet üretmek amacındadır. Ana Bilim Dalımızda da bu amaca uygun olarak içerdiği Çevre Mikrobiyolojisi Laboratuarı, Üretim Laboratuarı, Kimyasal Analiz Laboratuarı ve Mikrobiyal Taksonomi ve Kültür Koleksiyonları Laboratuarı'nda çeşitli çalışmalar yürütülmektedir.</p>
        <h4>Laboratuvarlar ve Çalışma Alanları</h4>
        <p><strong>Çevre Mikrobiyolojisi Laboratuarı:</strong> Çevre kirliliğine neden olan çeşitli atıkların (endüstriyel, tarımsal ve evsel atıklar) mikroorganizmalar aracılığı ile arıtılması ve renk giderimi gibi çalışmaların yanı sıra, mikrobiyal enzimler yardımı ile çeşitli kimyasalların toksik özelliklerinin giderilmesi gibi çalışmalar yapılmıştır.</p>
        <p><strong>Üretim Laboratuarı:</strong> Farklı mikrobiyal kaynaklardan çeşitli enzimlerin ve hormonların üretimi gerçekleştirilmiştir. Bunlar arasında; deterjan sanayinde kullanılan proteaz, lipaz ve amilaz, gıda sanayinde kullanılan laktaz, meyve ve sebze teknolojilerinde kullanılan pektinaz, yem ve kağıt sanayinde kullanılan ksilanaz, selülaz, ligninaz ve tirosinaz gibi çeşitli enzimlerin üretimi yer almaktadır. Ayrıca çeşitli bitki büyüme hormonlarının (giberellik asit ve indol asetik asit gibi) eldesi gerçekleştirilmektedir.</p>
        <p><strong>Mikrobiyal Taksonomi ve Kültür Koleksiyonları Laboratuarı:</strong> Çeşitli mikroorganizmaların tanısı ile ilgili çalışmaları sürdürülmektedir. Tür tanımlaması ve duyarlılık testlerinin yapılması yanı sıra; bu türlerin farklı moleküler tanı yöntemleri uygulanarak tiplendirilmesi ve aralarında mevcut olabilecek klonal ilişkinin araştırılması üzerine çalışmalar devam etmektedir. Ayrıca insan genetiği ile ilgili çalışmalar yapılmaktadır.</p>
        <p><strong>Kimyasal Analiz Laboratuarı:</strong> Tüm laboratuarlarımızda yapılan çalışmalar sürecinde gerekebilecek kimyasal analizlerin gerçekleştirilmesi sağlanmaktadır.</p>
        <p>Ana Bilim Dalımızda halen yukarıda sözü edilen laboratuarlarda çeşitli kurumların desteklediği projeler ve lisansüstü tez çalışmaları yürütülmektedir. Bu çalışmalarda 6'sı araştırma görevlisi kadrosunda olan toplam 11 genç araştırıcı özveriyle Ana Bilim Dalı Öğretim üye ve görevlilerinin gözetiminde çalışmaktadırlar. Bugüne kadar Ana Bilim Dalı Öğretim üye ve görevlileri tarafından 63 tezli yüksek lisans ve doktora tezi yönetilmiştir.</p>
        <h4>Dersler</h4>
        <p><strong>Lisans Dersleri:</strong> Genel Mikrobiyoloji I ve II, Parazitoloji, Modern Biyoloji II, Tıbbi Mikrobiyoloji, İmmünobiyoloji, Endüstriyel Mikrobiyoloji, Bakteri Fizyolojisi, Biyoteknolojiye Giriş, Moleküler Genetik, Deneysel Biyokimya, Mikropsal Teknolojisi</p>
        <p><strong>Lisansüstü Dersler:</strong> Anaerobik Mikroorganizmalar, Endüstriyel Enzimler, Biyokimyasal Evrim, Bakteri Metabolizması, Mikrobiyal Ekoloji, İmmünoteknoloji, Biyoteknolojide Sekonder Metabolitlerin Üretimi, İleri Çevre Mikrobiyolojisi, İleri Mikropsal Teknolojisi, Mikropsal Bozunma, İmmünobiyolojide Son Gelişmeler, Fermentasyon Biyoteknolojisi, Mikropsal Metal Zenginleştirme, Modern Biyoteknolojik Uygulamalar, Moleküler Bozuklukların Tanısında Biyoteknoloji I ve II, Çevre Biyoteknolojisi</p>
      `
    },
    {
        title: 'Botanik',
        content: `
            <p>1976 yılında Biyoloji Enstitüsü'nün bölüm haline dönüştürülmesiyle Botanik, Zooloji, Moleküler Biyoloji ve Genel Biyoloji programları da bölüm olarak ayrılmıştır. İlk Botanik Bölüm Başkanı, 1981 yılında bir trafik kazasında hayatını kaybeden, Türkiye'nin en önemli bitki sistematikçilerinden olan ve bölümdeki 2 no'lu dersliğe adı verilen Doç. Dr. Hasan Peşmen olmuştur. Doç. Dr. Hasan Peşmen'nin Botanik Bölümü'ne en önemli katkısı bu gün HUB olarak tescil edilen Herbaryum'un kuruluşundaki öncü çalışmalarıdır. Botanik Bölümü kurulduktan sonra Bitki Sistematiği, Bitki Fizyolojisi, Bitki Anatomisi ve Palinoloji alt bilim dallarına ayrılmıştır. Bölüm olarak kurulan Botanik, günümüzde Ana Bilim Dalı olarak faaliyetlerine devam etmektedir.</p>
            <p>Botanik Ana Bilim Dalında ulusal ve uluslar arası düzeyde ilk kurulan merkez, Herbaryum olmuştur. Herbaryumun ilk kuruluş çalışmaları 1973 yılında sınırlı sayıdaki bitki örnekleri ile başlamıştır. Herbaryumun uluslararası tescili ise 1977 yılında HUB olarak yapılmıştır. Ulusal ve uluslararası bitki değişimi ve kullanımına açık olup sistematikçilerin önemli ziyaret merkezleri arasındaki Herbaryum, 42.000 bitki örneğine ve 6.000 civarında tür sayısına sahip olup bünyesinde 1500 endemik ve 150 tip örneği bulunmaktadır.</p>
            <p>Bitki sistematiği biriminde yapılan çalışmalar, lokal floristik ve revizyon çalışmalarından ibarettir. Bir altyapı projesi ile geofit tipi bitkilerin yetiştirildiği zengin bir Hasbahçe kurulmuş ve araştırıcılar çalışmalarında buradan yararlanmaktadırlar.</p>
            <p>Bitki Fizyolojisi biriminde stres fizyolojisi çalışılmaktadır. Özellikle çevresel streslerin bitkilerde (Yüksek ve düşük sıcaklık, tuz, ağır metal, kuraklık v.s.) meydana getirdiği değişiklikler, in vivo ve intro olarak incelenmekte ve bu streslere karşı oluşturulan cevaplar; fizyolojik, biyokimyasal ve moleküler düzeyde araştırılmaktadır.</p>
            <p>Palinoloji alanında; aeropalinolojik, melisopalinolojik ve polen morfolojisi konusunda çalışmalar yapılmaktadır. Ayrıca son yıllarda olay yeri inceleme ekipleri tarafından gönderilen malzemelerde kriminal yönden palinolojik çalışmalar yapılarak adli hizmet de (Adli Palinoloji) sunulmaktadır. Palinoloji laboratuarında, 1500 farklı bitki türüne ait Türkiye'nin en zengin referans polen preparatı koleksiyonu bulunmaktadır. Palinolojiye bağlı olarak Arkeobotanik laboratuarı kurulmuş olup makrofosil bitki örnekleri üzerinde değerlendirmeler yapılmaktadır. Ana Bilim Dalında ayrıca sitogenetik ve sitotoksik çalışmalar da yapılmaktadır.</p>
            <p>Botanik ABD'nda halen; 6 Profesör, 2 Doçent, 1 Yardımcı Doçent, biri doktoralı 2 Uzman, yine biri doktoralı 7 Araştırma Görevlisi görev yapmaktadır.</p>
            <p>Botanik ABD'ında; 2010 yılına kadar 35 Yüksek Lisans, 24 Doktora tezi yaptırılmış, şu an 6 Yüksek Lisans ve 11 Doktora öğrencisi çalışmalarını sürdürmektedirler. Ayrıca toplam yaklaşık 82 ulusal ve uluslar arası destekli projelerde yürütücü ve araştırıcı olarak görev alınmıştır.</p>
        `
    },
    {
        title: 'Ekoloji',
        content: `
            <p>Ekoloji Ana Bilim Dalı, önceleri Biyoloji Bölümü Zooloji Ana Bilim Dalı içerisinde yer alırken, 1992 yılından itibaren bağımsız bir ana bilim dalı olarak eğitim-öğretim ve araştırma çalışmalarına başlamıştır. Ekoloji Ana Bilim Dalı Başkanlığı görevini ilk olarak Prof. Dr. M. Nihat Şişli ardından Prof. Dr. Ayşe Boşgelmez yürütmüştür ve şu anda da bu görevi Prof. Dr. Selim Süalp Çağlar yürütmektedir.</p>
            <p>Adını gururla taşıdığımız sevgili hocamız Prof. Dr. M. Nihat Şişli'nin hem Hacettepe Üniversitesi'nin hem de Biyoloji Bölümü'nün kurucularındandır. Türkiye'de Ekoloji ve Çevre Bilimleri konularındaki öncülerden biri olan hocamız Prof. Dr. M. Nihat Şişli'nin adı, 2001 yılında Hacettepe Üniversitesi Senatosu'nun da onayıyla, ana bilim dalımız bünyesindeki Ekoloji Laboratuarlarına verilerek "Prof. Dr. M. Nihat Şişli Ekolojik Bilimler Araştırma Laboratuarı (EBAL)" oluşturulmuştur.</p>
            <p>EBAL günümüzde ekoloji ve çevre bilimleri konusunda birçok araştırma ve eğitim faaliyetinin yürütülebileceği modern bir birim konumundadır Bünyesinde araştırma görevlileri, yüksek lisans ve doktora öğrencileri için modern bir ortak çalışma ofisi ve kütüphane, seminer ve toplantı salonu, kontrollü iklim odaları ve iklim kabinleri, Analiz, Morfometri ve Evrimsel Ekoloji (Pestisit Direnç, Moleküler Ekoloji, Coğrafi Bilgi Sistemi (GIS) ve Uzaktan Algılama) Laboratuarları yer almaktadır.</p>
            <p>Ekoloji Ana Bilim Dalı'nda ağırlıklı olarak; vektör ve zararlı organizmaların biyo-ekolojisi ve mücadelesi, biyolojik kontrol ve entomopatojen nematodlar,, pestisitlere karşı direnç gelişimi ve bitkisel kökenli biyopestisit araştırmaları, moleküler taksonomi, populasyon ve kommünite ekolojisi, orman yangın ekolojisi ve orman süksesyonu, memeli ekolojisi, parazit ekolojisi, vektör kökenli virüslerin araştırılması, ekolojik türleşme ve filogoğrafya, biyolojik çeşitlilik ve koruma, ekolojik modelleme, ekosistem planlaması ve yönetimi konularında çalışmalar yürütülmektedir.</p>
        `
    },
    {
        title: 'Genel Biyoloji',
        content: `
            <p>Genel Biyoloji Ana Bilim Dalı 1976 yılında "Genel Biyoloji Bölümü" olarak kurulmuş ve daha sonra 1981 yılında Biyoloji Bölümü içerisinde bir ana bilim dalı olarak yer almıştır.</p>
            <p>Genel Biyoloji Ana Bilim Dalının ilk Başkanı Prof Dr. Ahmet Noyan olmuştur. Daha sonraki Ana Bilim Dalı Başkanları Prof. Dr. Ali Nihat Bozcuk, Prof. Dr. Nazif Kolankaya, Prof. Dr. Emir Cansunar ve Prof. Dr. Mehmet Ali Onur olmuştur. Halen bu görevi Prof. Hacer Ünlü yürütmektedir.</p>
            <p>Ana Bilim Dalı içerisinde temel olarak dört bilim dalı bulunmaktadır: Hayvan ve Hücre Fizyolojisi, Genetik, Mikrobiyoloji ve Sitoloji.</p>
            <h4>Araştırma Laboratuvarları</h4>
            <p><strong>Fizyoloji Araştırma Grubu:</strong> Fizyoloji araştırma grubunda çalışmalar, fizyoloji laboratuvarı ve hücre kültürü laboratuvarlarında eş zamanlı olarak yürütülmektedir. Hücre kültürü laboratuvarında ise gerek primer kültürler, gerekse hücre hatları kullanılarak çok farklı tipte hücreler ile çalışma olanağı vardır.</p>
            <p><strong>Genetik Laboratuvarı:</strong> Drosophila melanogaster (sirke sineği) kullanılarak mutasyon test sistemleri ile bazı kimyasal ve fiziksel ajanların mutatör olarak etkileri araştırılmaktadır.</p>
            <p><strong>Evrimsel Genetik Laboratuvarı:</strong> Drosophila melanogaster ve farklı Drosophila türlerine ait doğal (yabanıl) populasyonlar kullanılarak enzim polimorfizmi, yaşam öyküsü karakterleri, gen-uyum bileşenleri arası ilişkiler çalışılmaktadır.</p>
            <p><strong>Sitoloji Laboratuvarı:</strong> Vücut sıvıları kullanılarak Kadın Hastalıkları ve Doğum Ana Bilim Dalı ile ortak çalışmalar yürütülmektedir. Çalışılan konular arasında Actinomyces, apopitotik değişiklikler, bakteriyel vajinoz, Wnt sinyal yolu, Human Papilloma Virus, Trichomonas vaginalis gibi konular yer almaktadır.</p>
        `
    },
    {
        title: 'Hidrobiyoloji',
        content: `
            <p>Hidrobiyoloji Ana Bilim Dalı, Biyoloji Bölümü, 1981 yılında Prof. Dr. Mustafa Kuru tarafından kurulmuştur. Ana Bilim Dalı, kurulduğu dönemden itibaren hidrobiyoloji alanında öncülük yapmakta ve evrensel bilgi birikimine, Türkiye'deki sucul ekosistemler üzerine yürütülen araştırmalarla önemli bilimsel katkılar sağlamaktadır. Halihazırda, Prof. Dr. Sedat V.Yerli Hidrobiyoloji Ana Bilim Dalı Başkanlığını yürütmektedir. Ana Bilim Dalı bünyesinde araştırma yürüten sekiz çalışma grubu ve laboratuvar bulunmaktadır.</p>
            <h4>Laboratuvarlar</h4>
            <ul>
                <li>Biomonitoring (Biyolojik İzleme) Laboratuvarı (Prof. Dr. Nilgün Kazancı)</li>
                <li>İhtiyoloji – Su Kimyası Laboratuvarı (Prof. Dr. Füsun Erk'akan)</li>
                <li>Tatlısu Balıkları Biyoloji ve Ekolojisi Laboratuvarı (Prof. Dr. Güler Ekmekçi)</li>
                <li>Sucul Yaşam Laboratuvarı (Prof. Dr. Sedat V. YERLİ)</li>
                <li>Acısular Laboratuvarı (Prof. Dr. F. Yıldız Demirkalp ve Doç. Dr. Yasemin Saygı)</li>
                <li>Plankton Laboratuvarı (Prof. Dr. Nuray Akbulut)</li>
                <li>Protozooloji Laboratuvarı (Yrd. Doç. Dr. Sırma Çapar)</li>
            </ul>
        `
    },
    {
        title: 'Moleküler Biyoloji',
        content: `
            <p>Moleküler Biyoloji Ana Bilim Dalı 1974 senesinde Prof.Dr. Altan Günalp öncülüğünde kurulmuştur. Biyoloji Bölümü Lisans programı dahilinde lisans öğrencilerine Moleküler Biyoloji, Moleküler Genetik, Biyokimya, Deneysel Biyokimya, Genel Viroloji, Genetik Mühendisliği gibi dersler verilmektedir.</p>
            <p>Yüksek lisans ve doktora programı kapsamında, biyomoleküller organizasyon prensipleri, hücre membranının yapısı, zar dinamiği, membran transportu, ileri biyokimyasal teknikler, enstrumental analiz, insan biyokimyası, enzimatik regülasyon, nükleik asit biyokimyası, bakteri genetiği, mutajen ve karsinojenlerin molekül biyokimyası genomik ve proteomik, kanser genetiği, uygulamalı moleküler biyoloji teknikleri ve moleküler sistematik gibi farklı alanlarda dersler verilmektedir.</p>
            <h4>Laboratuvarlar</h4>
            <p>Moleküler Biyoloji Ana Bilim Dalı bünyesinde DNA Araştırma Laboratuvarı 1, DNA Araştırma Laboratuvarı 2, DNA Araştırma Laboratuvarı 3, Moleküler Biyoloji Laboratuvarı 1, Moleküler Biyoloji Laboratuvarı 2 ve Bakteri Genetiği Laboratuvarı olmak üzere 6 laboratuvar bulunmaktadır.</p>
        `
    },
    {
        title: 'Uygulamalı Biyoloji',
        content: `
            <p>Uygulamalı Biyoloji Ana Bilim Dalı 1992 yılında kurulmuştur. 1992-2006 yılları arasında Ana Bilim Dalı Başkanlığı Prof. Dr. Neşe Çağatay tarafından sürdürülmüştür. 2006-2009 yılları arasındaki Ana Bilim Dalı Başkanlığı görevi Prof. Dr. Nevin Keskin tarafından devam ettirilmiş olup, şu anki Ana bilim Dalı Başkanımız Prof. Dr. Kadriye Sorkun'dur.</p>
            <p>Çalışma konuları arasında Bal Arılarının Virütik, Mikrobiyal ve Paraziter Hastalıkları, Irkların Direnç Mekanizmaları, Entomopatojen Nematodlar, Mikrobiyoloji, Parazitoloji, Arı ürünleri (bal, polen, propolis), Sistematik Entomoloji, Adli Entomoloji, Tozlaşma, Organik Tarım bulunmaktadır.</p>
            <h4>Araştırma Laboratuvarları</h4>
            <ul>
                <li>Arı Sağlığı Laboratuvarı</li>
                <li>Biyokriminal Entomoloji Laboratuvarı</li>
                <li>Entomoloji Laboratuvarı</li>
                <li>Entomopatojen Nematod Laboratuvarı</li>
                <li>Palinoloji Laboratuvarı</li>
            </ul>
        `
    },
    {
        title: 'Zooloji',
        content: `
            <p>1973 yılında kurulan Zooloji Bölümü, 1982 yılından bu yana üniversitemiz Fen Fakültesi, Biyoloji Bölümü bünyesinde Ana Bilim Dalı olarak yer almaktadır. Halen Ana Bilim Dalı başkanlığı görevi, Prof. Dr. Dürdane Kolankaya tarafından yürütülmektedir.</p>
            <p>Ana Bilim Dalı içinde Hücre Biyolojisi, Gelişim Biyolojisi, Histoloji, Entomoloji, Ornitoloji ve Sistematik Zooloji, Toksikoloji ve Ekotoksikoloji alanlarında çalışmalar yapılmaktadır. Ana Bilim Dalı bünyesinde Zooloji Müzesi (HÜZOM) bulunmaktadır. 1979 yılında Prof. Dr. Ali Demirsoy'un kişisel çabalarıyla kurulan müze, sahip olduğu Ulusal ve Uluslararası öneme sahip insekta kolleksiyonuyla önemli bir yere sahiptir.</p>
            <h4>Araştırma Laboratuvarları</h4>
            <ul>
                <li>Hücre Biyolojisi Laboratuvarı</li>
                <li>Histoloji Laboratuvarı</li>
                <li>Entomoloji Laboratuvarı</li>
                <li>Ornitoloji Laboratuvarı</li>
                <li>Toksikoloji ve Ekotoksikoloji Laboratuvarı</li>
            </ul>
        `
    },
];

const facilitiesData = [
    { name: 'Ofis', count: 80, capacity: 116 },
    { name: 'Derslik', count: 10, capacity: 576 },
    { name: 'Öğrenci Laboratuvarı', count: 7, capacity: 350 },
    { name: 'Bilgisayar Laboratuvarı', count: 1, capacity: 46 },
    { name: 'Müze', count: 1, capacity: null },
    { name: 'Herbaryum', count: 1, capacity: null },
    { name: 'Toplantı Odası', count: 1, capacity: 10 },
    { name: 'Seminer Odası', count: 4, capacity: 30 },
    { name: 'Konferans Salonu', count: 1, capacity: 102 },
    { name: 'Öğrenci Topluluk Odası', count: 1, capacity: 25 },
    { name: 'Teksir Odası', count: 1, capacity: null },
    { name: 'Bitki Kurutma Odası', count: 1, capacity: null },
    { name: 'İklim Odası', count: 1, capacity: null },
    { name: 'Çay Odası', count: 3, capacity: null },
    { name: 'Kimyasal Depo', count: 3, capacity: null },
    { name: 'Depo', count: 5, capacity: null },
    { name: 'Temizlik Malzeme Deposu', count: 1, capacity: null },
];

const statsData = [
    { icon: FaUsers, count: "8", label: "Ana Bilim Dalı" },
    { icon: FaMicroscope, count: "50+", label: "Laboratuvar" },
    { icon: FaGraduationCap, count: "1000+", label: "Mezun" },
    { icon: FaFlask, count: "100+", label: "Araştırma" },
];

// --- Bileşenler ---

const HeroSection = () => (
    <div className="biology-hero">
        <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
        >
            Biyoloji Bölümü
        </motion.h1>
        <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
        >
            Yaşam Bilimlerinin Kalbinde, Geleceği Şekillendiriyoruz
        </motion.p>
                        </div>
);

const Section = ({ title, subtitle, children, delay = 0 }) => (
    <motion.div 
        className="biology-section"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.6, delay }}
    >
        <div className="section-header">
            <h2 className="section-title">{title}</h2>
            {subtitle && <p className="section-subtitle">{subtitle}</p>}
                    </div>
        <div className="section-content">
            {children}
        </div>
    </motion.div>
);

const TanitimSection = () => (
    <Section title="Bölüm Tanıtımı" subtitle="Yaşam bilimlerinde öncü eğitim ve araştırma merkezi">
        <div className="creative-cards-grid">
            <div className="creative-card">
                <h4><FaDna style={{ marginRight: '0.5rem', color: '#667eea' }} />Biyolog Kimdir?</h4>
                <p>
                    Biyolog, dünya üzerinde yaşayan tüm canlıları ve onların çevreleriyle etkileşimlerini inceleyerek analiz eden, hastalıkların mekanizmasını ortaya çıkararak analiz yöntemleri geliştiren, ilaç geliştirme çalışmalarını yapan, sağlık araştırmalarında ve pandemi durumlarında etkin rol oynayan, gıda ve su analizleri yapan, ekosistemi anlayarak biyoçeşitlilik ve çevre kirliliği ile ilgili çalışmalar yapan uzmanlarımızdır.
                </p>
            </div>
            <div className="creative-card">
                <h4><FaLeaf style={{ marginRight: '0.5rem', color: '#4facfe' }} />Tarihçe</h4>
                <p>
                    Biyoloji Enstitüsü 1965 yılında kuruldu. 1967 yılında Hacettepe Üniversitesinin kurulmasıyla birlikte Üniversitenin Fen ve Mühendislik Fakültelerine bağlanan Biyoloji Enstitüsünün ilk Bölüm Başkanlığını Doç.Dr. Altan Günalp üstlenmiştir. 1971 yılında Hacettepe Üniversitesi Fen Fakültesinin kurulmasıyla birlikte Biyoloji Bölümü bu fakülte bünyesine katılmıştır.
                </p>
            </div>
        </div>
    </Section>
);

const YonetimSection = () => (
    <Section title="Yönetim Kadrosu" subtitle="Deneyimli akademik liderlik ekibimiz">
        <div className="management-grid">
            {managementData.map((person, index) => (
            <motion.div 
                    key={index} 
                    className="management-card"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                >
                    <div className="management-card-content">
                        <img src={person.img} alt={person.name} />
                        <h4 className="management-card-name">{person.name}</h4>
                        <p className="management-card-title">{person.title}</p>
                        <a href={`mailto:${person.email}`} className="management-card-email">
                            <FaEnvelope />
                            İletişim
                                </a>
                            </div>
                        </motion.div>
                    ))}
        </div>
    </Section>
);

const AccordionItem = ({ title, content, isOpen, onClick, index }) => {
    return (
        <motion.div 
            className="accordion-item"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
        >
            <button className={`accordion-title ${isOpen ? 'open' : ''}`} onClick={onClick}>
                {title}
                <FaChevronDown className="accordion-icon" />
            </button>
            <div className={`accordion-content ${isOpen ? 'open' : ''}`}>
                <div className="accordion-content-inner" dangerouslySetInnerHTML={{ __html: content }} />
            </div>
        </motion.div>
    );
};

const AnaBilimDallariSection = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const handleToggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <Section title="Ana Bilim Dalları" subtitle="8 farklı ana bilim dalında çok disiplinli araştırma ve eğitim">
            <div className="accordion-container">
                {anaBilimDallariData.map((item, index) => (
                    <AccordionItem
                        key={index}
                        index={index}
                        title={item.title}
                        content={item.content}
                        isOpen={openIndex === index}
                        onClick={() => handleToggle(index)}
                    />
                ))}
            </div>
        </Section>
    );
};

const FizikselOlanaklarSection = () => (
    <Section title="Fiziksel Olanaklar" subtitle="Modern araştırma ve eğitim altyapısı">
        <p style={{ marginBottom: '2rem', fontSize: '1.1rem', color: '#4a5568' }}>
            Bölümümüzün tüm dersliklerinde internet bağlantısı ve sunum olanakları sağlanmaktadır. 
            Öğrencilerimizin kullanımına açık olan bilgisayar laboratuvarımızın yanı sıra, 
            102 kişilik bir konferans salonumuz da bulunmaktadır.
        </p>
        <div className="facilities-table-container">
            <table className="facilities-table">
                <thead>
                    <tr>
                        <th>Mekan Adı</th>
                        <th>Adet</th>
                        <th>Kapasite (kişi)</th>
                    </tr>
                </thead>
                <tbody>
                    {facilitiesData.map((facility, index) => (
                        <motion.tr 
                            key={index}
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: index * 0.05 }}
                        >
                            <td>{facility.name}</td>
                            <td>{facility.count}</td>
                            <td>{facility.capacity || '-'}</td>
                        </motion.tr>
                    ))}
                </tbody>
            </table>
        </div>
    </Section>
);

const MerkezlerSection = () => (
    <Section title="Araştırma Merkezlerimiz" subtitle="Ulusal ve uluslararası öneme sahip koleksiyonlar">
        <div className="creative-cards-grid">
            <motion.div 
                className="creative-card"
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.3 }}
            >
                <h4>Herbaryum (HUB)</h4>
                <p>
                    1973 yılında kurulmuş, 42.000 örneğe sahip herbaryumumuz Türkiye'nin en zengin 
                    bitki koleksiyonlarından biridir. Edinburgh, Cenevre ve Viyana gibi dünya çapındaki 
                    herbaryumlarla aktif örnek değişimi yapmaktadır.
                </p>
            </motion.div>
        <motion.div 
                className="creative-card"
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.3 }}
            >
                <h4>Zooloji Müzesi (HUZOM)</h4>
                <p>
                    1979 yılında kurulan müzemiz, 200.000'in üzerinde hayvan örneği ve zengin 
                    İnsecta koleksiyonu ile ulusal ve uluslararası öneme sahiptir. Yılda ortalama 
                    5.000 ziyaretçiyi ağırlamaktadır.
                </p>
            </motion.div>
                </div>
    </Section>
);

const ProgramlarSection = () => (
    <Section title="Eğitim Programları" subtitle="Çok yönlü akademik fırsatlar">
        <div className="creative-cards-grid">
            <div className="creative-card">
                <h4>Yan Dal & Çift Ana Dal</h4>
                <p><strong>Yan Dal:</strong> 2.75 GANO ve 7 ders başarı koşuluyla sertifika</p>
                <p><strong>Çift Ana Dal:</strong> Aktüerya, Kimya, İstatistik, Matematik ve Felsefe bölümlerinden diploma</p>
            </div>
            <div className="creative-card">
                <h4>Uluslararası Programlar</h4>
                <p><strong>Erasmus:</strong> Belçika, Almanya, Fransa, Polonya</p>
                <p><strong>Değişim:</strong> Mevlana ve Farabi programları</p>
            </div>
            <div className="creative-card">
                <h4>Kariyer Olanakları</h4>
                <p>Sağlık, çevre, tarım, Ar-Ge sektörlerinde geniş iş imkanları. 
                İsteğe bağlı staj programları ve sektör deneyimi.</p>
            </div>
            </div>
    </Section>
);

const FloatingStats = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setIsVisible(true), 2000);
        return () => clearTimeout(timer);
    }, []);

    if (!isVisible) return null;

    return (
        <div className="floating-stats">
            {statsData.map((stat, index) => (
                <motion.div
                    key={index}
                    className="stat-bubble"
                    initial={{ opacity: 0, scale: 0 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.5, delay: index * 0.2 }}
                    whileHover={{ scale: 1.1 }}
                >
                    <stat.icon style={{ marginRight: '0.5rem' }} />
                    {stat.count} {stat.label}
                </motion.div>
            ))}
        </div>
    );
};

// --- Ana Bileşen ---

const Biology = () => {
    return (
        <PageTemplate 
            title=""
            subtitle=""
        >
            <div className="biology-page-container">
                <div className="biology-content-wrapper">
                    <HeroSection />
                    <TanitimSection />
                    <YonetimSection />
                    <AnaBilimDallariSection />
                    <FizikselOlanaklarSection />
                    <MerkezlerSection />
                    <ProgramlarSection />
                </div>
                <FloatingStats />
            </div>
        </PageTemplate>
    );
};

export default Biology;